import { z } from 'zod';
import {
  Attribution,
  Cid,
  EventName,
  SessionKey,
  SiteId,
  TenantId,
  VideoCtaAttribution,
  VisitorKey,
} from './common';

export const EventRequest = z.object({
  tenant_id: TenantId,
  site_id: SiteId,
  landing_page_id: z.string().regex(/^lp_[a-zA-Z0-9_-]{1,61}$/),
  visitor_id: VisitorKey,
  session_id: SessionKey,
  cid: Cid.nullable().optional(),
  event_name: EventName,
  page_location: z.string().url().max(2048).optional(),
  referrer: z.string().max(2048).nullable().optional(),

  video: z.object({
    video_id: z.string().min(1).max(128),
    video_title: z.string().min(1).max(255),
    video_url: z.string().max(2048).nullable().optional(),
    poster_url: z.string().url().max(2048).nullable().optional(),
    detected_title: z.string().max(255).nullable().optional(),
    source_url: z.string().url().max(2048).nullable().optional(),
    page_heading: z.string().max(255).nullable().optional(),
    video_percent: z.number().int().min(0).max(100).optional(),
    video_max_percent: z.number().int().min(0).max(100).optional(),
    video_last_position: z.number().min(0).optional(),
    video_duration: z.number().min(0).optional(),
    video_completed: z.boolean().optional(),
    video_cta_clicked: z.boolean().optional(),
    video_cta_id: z.string().max(128).nullable().optional(),
    video_cta_name: z.string().max(255).nullable().optional(),
    video_cta_attribution: VideoCtaAttribution.optional(),
  }),

  attribution: Attribution.optional(),
  occurred_at: z.string().datetime(),
});

export type EventRequest = z.infer<typeof EventRequest>;
